import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  details: {
    data: [],
    units: {},
    paginatedElements: 0,
  }
};
const wellsDrillFluidReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        errorMessage: ''
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_SET_ID:
      return {
        ...state,
        drillFluidId: action.payload.data
      };

    case REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_LOADING:
      return {
        ...state,
        details: {
          ...state.details,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          data: [...action.payload.data],
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_DETAILS_LIST_ERROR:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    default:
      return state;
  }
};
export default wellsDrillFluidReducer;
